import React, { useState } from 'react';
import { Modal, Button } from "react-bootstrap";
import ChangeStatusLogo from '../src/image/edit.gif'

const StatusChangeModal = ({ open, onClose, onConfirm }) => {

  const [errorMessage, setErrorMessage] = useState();
  return (
    <>
    {open && <div className="custom-backdrop" />}

    <Modal
      size="md"
      show={open}
      style={{ zIndex: 1300 }}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      {/* HEADER */}
      <Modal.Header closeButton>
        <span className="w-100  text-dark fw-bold">
          Change Status
        </span>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body className="text-center" style={{ maxHeight: "45vh", overflow: "auto" }}>
        <img src={ChangeStatusLogo} alt="" className='mt-5' />
        <h6 className="fs-5 fw-semibold text-dark mb-3 p-4">Are you sure you want to change the status?</h6>

        {errorMessage && (
          <span style={{ color: "red", fontSize: "0.9rem" }}>{errorMessage}</span>
        )}
      </Modal.Body>

      {/* FOOTER */}
      <Modal.Footer className="d-flex justify-content-end">

        <Button variant="primary" className="rts-btn ms-2" onClick={onConfirm}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
    </>


  );
};
export default StatusChangeModal;
